import { render, staticRenderFns } from "./CourseTestForm.vue?vue&type=template&id=4f7b1feb&scoped=true&"
import script from "./CourseTestForm.vue?vue&type=script&lang=js&"
export * from "./CourseTestForm.vue?vue&type=script&lang=js&"
import style0 from "./CourseTestForm.vue?vue&type=style&index=0&id=4f7b1feb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f7b1feb",
  null
  
)

export default component.exports